/* PANTHEION THEME — main.js */
var site=(function(){
'use strict';

/* ── OVERLAY ── */
var ov=document.getElementById('overlay');
function showOv(){if(ov){ov.classList.add('on');document.body.style.overflow='hidden'}}
function hideOv(){if(ov){ov.classList.remove('on');document.body.style.overflow=''}}

function closeAll(){
  hideMobNav();hideCart();hideSearch();hideFD();
  document.querySelectorAll('.dd.on').forEach(function(d){d.classList.remove('on')});
  document.querySelectorAll('.nav-item.open').forEach(function(n){n.classList.remove('open')});
  hideOv();
}

/* ── HEADER SCROLL ── */
var hdr=document.querySelector('.site-header');
if(hdr)window.addEventListener('scroll',function(){hdr.classList.toggle('scrolled',window.scrollY>6)},{passive:true});

/* ── DROPDOWNS (hover on desktop) ── */
var ddItems=document.querySelectorAll('.nav-item[data-dd]');
var ddT;
ddItems.forEach(function(item){
  item.addEventListener('mouseenter',function(){
    clearTimeout(ddT);
    document.querySelectorAll('.dd.on').forEach(function(d){d.classList.remove('on')});
    document.querySelectorAll('.nav-item.open').forEach(function(n){n.classList.remove('open')});
    var dd=document.getElementById(item.dataset.dd);
    if(dd){dd.classList.add('on');item.classList.add('open');showOv()}
  });
  item.addEventListener('mouseleave',function(){
    var dd=document.getElementById(item.dataset.dd);
    ddT=setTimeout(function(){
      if(dd)dd.classList.remove('on');
      item.classList.remove('open');hideOv();
    },120);
    if(dd){
      dd.addEventListener('mouseenter',function(){clearTimeout(ddT)},{once:true});
      dd.addEventListener('mouseleave',function(){
        ddT=setTimeout(function(){dd.classList.remove('on');item.classList.remove('open');hideOv()},120);
      },{once:true});
    }
  });
});

/* ── MOBILE NAV ── */
var mobNav=document.getElementById('mob-nav');
function showMobNav(){if(mobNav){mobNav.classList.add('on');showOv()}}
function hideMobNav(){if(mobNav)mobNav.classList.remove('on')}
document.querySelectorAll('[data-open-nav]').forEach(function(b){b.addEventListener('click',showMobNav)});
document.querySelectorAll('[data-close-nav]').forEach(function(b){b.addEventListener('click',function(){hideMobNav();hideOv()})});
document.querySelectorAll('.mob-row[data-sub]').forEach(function(row){
  row.addEventListener('click',function(){
    var sub=document.getElementById(row.dataset.sub);
    if(sub){sub.classList.toggle('on');row.classList.toggle('open')}
  });
});

/* ── SEARCH ── */
var sd=document.getElementById('search-drawer');
var si=document.getElementById('search-input');
function showSearch(){if(sd){sd.classList.add('on');showOv();setTimeout(function(){if(si)si.focus()},250)}}
function hideSearch(){if(sd)sd.classList.remove('on')}
document.querySelectorAll('[data-open-search]').forEach(function(b){b.addEventListener('click',showSearch)});
document.querySelectorAll('[data-close-search]').forEach(function(b){b.addEventListener('click',function(){hideSearch();hideOv()})});
document.addEventListener('keydown',function(e){if(e.key==='Escape')closeAll()});

/* ── CART DRAWER ── */
var cd=document.getElementById('cart-drawer');
function showCart(){if(cd){cd.classList.add('on');showOv()}}
function hideCart(){if(cd)cd.classList.remove('on')}
document.querySelectorAll('[data-open-cart]').forEach(function(b){b.addEventListener('click',showCart)});
document.querySelectorAll('[data-close-cart]').forEach(function(b){b.addEventListener('click',function(){hideCart();hideOv()})});

/* ── CART AJAX ── */
function updateBadge(n){document.querySelectorAll('.cart-badge').forEach(function(el){el.textContent=n;el.style.display=n>0?'flex':'none'})}
function showToast(msg){var t=document.getElementById('toast');if(!t)return;t.textContent=msg;t.classList.add('on');clearTimeout(t._t);t._t=setTimeout(function(){t.classList.remove('on')},2800)}
async function refreshCart(){
  try{
    var r=await fetch('/cart.js');var c=await r.json();updateBadge(c.item_count);
    var sr=await fetch('/?sections=cart-drawer');var sd2=await sr.json();
    if(sd2['cart-drawer']&&cd){
      var tmp=document.createElement('div');tmp.innerHTML=sd2['cart-drawer'];
      var nc=tmp.querySelector('.cart-drawer');if(nc)cd.innerHTML=nc.innerHTML;
      bindCart();
    }
  }catch(e){}
}
window.addToCart=async function(vid,qty,btn){
  var orig=btn?btn.textContent:'';
  if(btn){btn.disabled=true;btn.textContent='Adding...'}
  try{
    var r=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:vid,quantity:qty||1})});
    var d=await r.json();if(d.status)throw new Error(d.description||'Could not add to bag');
    await refreshCart();showCart();showToast('Added to bag ✓');
  }catch(e){showToast(e.message)}
  finally{if(btn){btn.disabled=false;btn.textContent=orig}}
};
async function changeLine(line,qty){
  await fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({line:line,quantity:qty})});
  await refreshCart();
}
function bindCart(){
  document.querySelectorAll('[data-qdec]').forEach(function(b){b.addEventListener('click',function(){var v=b.closest('.qty-wrap').querySelector('.qty-val');changeLine(+b.dataset.qdec,Math.max(0,+v.textContent-1))})});
  document.querySelectorAll('[data-qinc]').forEach(function(b){b.addEventListener('click',function(){var v=b.closest('.qty-wrap').querySelector('.qty-val');changeLine(+b.dataset.qinc,+v.textContent+1)})});
  document.querySelectorAll('[data-rem]').forEach(function(b){b.addEventListener('click',function(){changeLine(+b.dataset.rem,0)})});
  document.querySelectorAll('[data-close-cart]').forEach(function(b){b.addEventListener('click',function(){hideCart();hideOv()})});
}
bindCart();
fetch('/cart.js').then(function(r){return r.json()}).then(function(c){updateBadge(c.item_count)}).catch(function(){});

/* ── QUICK ADD ── */
document.addEventListener('click',async function(e){
  var s=e.target.closest('.qa-size[data-vid]');
  if(!s||s.classList.contains('oos'))return;
  await window.addToCart(s.dataset.vid,1,null);
});

/* ── GENDER TABS ── */
document.querySelectorAll('[data-tabs]').forEach(function(wrap){
  wrap.querySelectorAll('.tab-btn').forEach(function(btn){
    btn.addEventListener('click',function(){
      wrap.querySelectorAll('.tab-btn').forEach(function(b){b.classList.remove('on')});
      wrap.querySelectorAll('.tab-panel').forEach(function(p){p.classList.remove('on')});
      btn.classList.add('on');
      var panel=document.getElementById(btn.dataset.tab);if(panel)panel.classList.add('on');
    });
  });
});

/* ── FILTER DRAWER ── */
var fdEl=document.getElementById('filter-drawer');
function showFD(){if(fdEl){fdEl.classList.add('on');showOv()}}
function hideFD(){if(fdEl)fdEl.classList.remove('on')}
document.querySelectorAll('[data-open-filter]').forEach(function(b){b.addEventListener('click',showFD)});
document.querySelectorAll('[data-close-filter]').forEach(function(b){b.addEventListener('click',function(){hideFD();hideOv()})});
document.querySelectorAll('.fd-group-title').forEach(function(t){t.addEventListener('click',function(){t.closest('.fd-group').classList.toggle('open')})});

/* ── PRODUCT PAGE ── */
var atbBtn=document.getElementById('atb-btn');
var stickyBtn=document.getElementById('sticky-btn');
var varIn=document.getElementById('var-in');
var selVid=null;
var szBtns=document.querySelectorAll('.size-opt');
if(szBtns.length&&atbBtn&&!atbBtn.dataset.def){atbBtn.disabled=true;atbBtn.textContent='Select a Size'}
szBtns.forEach(function(btn){
  btn.addEventListener('click',function(){
    if(btn.classList.contains('oos'))return;
    szBtns.forEach(function(b){b.classList.remove('on')});btn.classList.add('on');
    selVid=btn.dataset.vid;if(varIn)varIn.value=selVid;
    var p=btn.dataset.price;if(p){var el=document.getElementById('price-main');if(el)el.textContent=p}
    if(atbBtn){atbBtn.disabled=false;atbBtn.textContent='Add to Bag'}
    if(stickyBtn){stickyBtn.disabled=false;stickyBtn.textContent='Add to Bag'}
  });
});
async function doAtb(btn){
  var vid=selVid||(varIn&&varIn.value);
  if(!vid){showToast('Please select a size');return}
  await window.addToCart(vid,1,btn);
}
if(atbBtn)atbBtn.addEventListener('click',function(){doAtb(atbBtn)});
if(stickyBtn)stickyBtn.addEventListener('click',function(){doAtb(stickyBtn)});
/* Sticky ATB show/hide */
if(atbBtn){var sbar=document.querySelector('.sticky-atb');if('IntersectionObserver'in window&&sbar){new IntersectionObserver(function(e){sbar.style.display=e[0].isIntersecting?'none':'block'}).observe(atbBtn)}}
/* Gallery */
var mImg=document.getElementById('main-img');
document.querySelectorAll('.gallery-thumb').forEach(function(t){t.addEventListener('click',function(){document.querySelectorAll('.gallery-thumb').forEach(function(x){x.classList.remove('on')});t.classList.add('on');if(mImg&&t.dataset.src)mImg.src=t.dataset.src})});
/* Accordions */
document.querySelectorAll('.accord-btn').forEach(function(btn){btn.addEventListener('click',function(){var body=btn.nextElementSibling;var was=btn.classList.contains('on');btn.closest('.accord').querySelectorAll('.accord-btn').forEach(function(b){b.classList.remove('on');if(b.nextElementSibling)b.nextElementSibling.classList.remove('on')});if(!was){btn.classList.add('on');if(body)body.classList.add('on')}})});
/* Wishlist */
document.querySelectorAll('[data-wish]').forEach(function(b){b.addEventListener('click',function(){b.classList.toggle('on')})});

/* ── TICKER ── */
var tSlides=document.querySelectorAll('.ticker-slide');
var tIdx=0;var tT;
function nextSlide(){tSlides[tIdx].classList.remove('on');tIdx=(tIdx+1)%tSlides.length;tSlides[tIdx].classList.add('on')}
function prevSlide(){tSlides[tIdx].classList.remove('on');tIdx=(tIdx-1+tSlides.length)%tSlides.length;tSlides[tIdx].classList.add('on')}
if(tSlides.length){
  tSlides[0].classList.add('on');
  if(tSlides.length>1){
    tT=setInterval(nextSlide,4000);
    var tp=document.querySelector('.ticker-btn.prev');var tn=document.querySelector('.ticker-btn.next');
    if(tp)tp.addEventListener('click',function(){clearInterval(tT);prevSlide();tT=setInterval(nextSlide,4000)});
    if(tn)tn.addEventListener('click',function(){clearInterval(tT);nextSlide();tT=setInterval(nextSlide,4000)});
  }
}

return{closeAll:closeAll};
})();
